/*  ==========================================================================
    DYNFORMS CONFIG
    ========================================================================== */

/*
 * IMPORTS
 */

import $ from 'jquery';
import * as vars from '../../globals/variables';
import {params} from './params/params';

/*
 * YOUR CODE
 */

//Bei globalDynForms nur den Dynfromcode des Wrappers verwenden
let globalDynForms = {
    // 'std_request_2017': {
    //     urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
    //     // additionals: true,
    //     colors: {
    //         'color1': vars.dynformsColors.colorPRIMARY, // Farbe der Input Labels, Farbe des Kalenders, Section Linie
    //         'color2': vars.dynformsColors.colorTEXT, // Farbe des Section Titels, Farbe der Zimmerbeschreibung, Farbe Beschreibungstext Einwilligung Marketing/Profilierung, Hoverfarbe X Zimmer entfernen
    //         'color3': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Hoverfarbe Absenden Button, Farbe des Popups beim Hovern
    //         'color4': vars.dynformsColors.colorTEXT, // Farbe Input Felder, Farbe des Popup, Titel Zimmername
    //         'color5': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern, Farbe Checkbox Icon ausgewählt, Hintergrundfarbe Popup
    //         'color6': vars.dynformsColors.colorPRIMARY, // Farbe Einwilligung Marketing/Profilierung + Checkbox Border
    //         'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
    //         'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
    //     },
    //     offer_id: params.offer,
    //     last_minute: params.lastminute_code,
    //     roomcodes: params.roomcodes,
    //     fieldOverride: {
    //         fromdate: params.fromdate,
    //         todate: params.todate
    //     },
    //     onFormReady: function () {
    //         const container = document.getElementById(this.formContainerId);
    //         if(container.classList.contains('popupForm')) {
    //             let slider = container.closest('.slick-list');
    //             slider.style.height = "auto";
    //         }
    //     }
    // },
    'std_newsletter_2017': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_newsletter + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorSECONDARY, // Farbe der Input Felder & Input Labels
            'color2': vars.dynformsColors.colorCustom, // Hintergrundfarbe Absenden Button, Farbe Popup Text beim Hovern
            'color3': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        }
    },
    'std_reservation_2017': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // line
            'color2': vars.dynformsColors.colorTEXT, // text color
            'color3': vars.dynformsColors.colorPRIMARY, // button bg
            'color4': vars.dynformsColors.colorTEXT, // text color
            'color5': vars.dynformsColors.colorSECONDARY, // button text color
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        onFormReady: function () {
            var langField = document.getElementsByClassName("bn-form__column--reservation_language")[0];
            langField.classList.remove("bn-form__hidden");
        }
    },
    'std_reservation_2017_warmbaderhof': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // line
            'color2': vars.dynformsColors.colorTEXT, // text color
            'color3': vars.dynformsColors.colorPRIMARY, // button bg
            'color4': vars.dynformsColors.colorTEXT, // text color
            'color5': vars.dynformsColors.colorSECONDARY, // button text color
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        onFormReady: function () {
            var langField = document.getElementsByClassName("bn-form__column--reservation_language")[0];
            langField.classList.remove("bn-form__hidden");
        }
    }
};

//Bei specialDynforms nur die IDs des Wrappers verwenden
let specificDynforms = {
    'bn_quickrequest_vertical': {
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color2': vars.dynformsColors.colorSECONDARY, // Farbe Input Labels & Inputs
            'color3': vars.dynformsColors.colorSECONDARY, // Hintergrundfarbe Absenden Button
            'color4': vars.dynformsColors.colorPRIMARY, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        }
    },
    'bn_newsletter_v3': {
        colors: {
            'color1': vars.dynformsColors.colorTEXT, // Farbe der Input Felder & Input Labels
            'color2': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Farbe Popup Text beim Hovern
            'color3': vars.dynformsColors.colorCustom, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        }
    }
};

export {
    globalDynForms,
    specificDynforms
};



// WEBPACK FOOTER //
// ./source/js/ehotelier/dynforms/config.js